import React from "react";
import { ErrorBoundary } from "@action.sustainability/storybook-dashboard/errors";
import { useModalBase } from "./hooks";
import ModalContainer from "./components";

const ModalContext = React.createContext();

function ModalProvider({ children }) {
  const { setModal, modalContent, modalFullWidth } = useModalBase();
  return (
    <ModalContext.Provider value={{ setModal, modalContent, modalFullWidth }}>
      <ErrorBoundary>
        <ModalContainer />
      </ErrorBoundary>
      {children}
    </ModalContext.Provider>
  );
}

export { ModalContext, ModalProvider };
